function getOrderOnlineLink(title) {
  const linkMap = {
    "p-georgies-beer-and-wine": "https://orders.iorders.online/p-georgies-beer-and-wine",
    "p-stans-place-saskatoon": "https://orders.iorders.online/p-stans-place-saskatoon",
    "p-pabco-liquor-prince-albert": "https://orders.iorders.online/p-pabco-liquor-prince-albert",
    "p-jolly-roger-regina": "https://orders.iorders.online/p-jolly-roger-regina",
    "p-liquor-store-uptown-moosomin": "https://orders.iorders.online/p-liquor-store-uptown-moosomin",
    "red-lion-liquor-store-kindersley-5143": "https://orders.iorders.online/red-lion-liquor-store-kindersley-5143",
  };
  
  return linkMap[title] || `https://orders.iorders.online/${title}`;
}

// ... rest of the code remains unchanged
const storeDetails = {
  status: "success",
  data: {
    restaurants: [
      //1. Georgie's Beer & Wine Store, Prince Albert
      {
        profile: {
          id: 124,
          restaurant_name: "Georgie's Beer & Wine Store, Prince Albert",
          title: "p-georgies-beer-and-wine",
          address: "906 1 Ave W, Prince Albert, SK S6V 4Y2, Canada",
          phone: "+1 (306) 764-5240",
          available_days: [
            {
              id: 1746,
              day: "SUNDAY",
              opening_time: "10:00:00",
              closing_time: "23:00:00",
              order_mode: 1,
            },
            {
              id: 1747,
              day: "MONDAY",
              opening_time: "10:00:00",
              closing_time: "23:00:00",
              order_mode: 1,
            },
            {
              id: 1748,
              day: "TUESDAY",
              opening_time: "10:00:00",
              closing_time: "23:00:00",
              order_mode: 1,
            },
            {
              id: 1749,
              day: "WEDNESDAY",
              opening_time: "10:00:00",
              closing_time: "23:00:00",
              order_mode: 1,
            },
            {
              id: 1750,
              day: "THURSDAY",
              opening_time: "10:00:00",
              closing_time: "23:00:00",
              order_mode: 1,
            },
            {
              id: 1751,
              day: "FRIDAY",
              opening_time: "10:00:00",
              closing_time: "23:00:00",
              order_mode: 1,
            },
            {
              id: 1752,
              day: "SATURDAY",
              opening_time: "10:00:00",
              closing_time: "23:00:00",
              order_mode: 1,
            },
          ],
          close_restaurent: false,
          lat: "53.20450409612867",
          lng: "-105.75630537881534",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },
      //2. Stans Place Saskatoon
      {
        profile: {
          id: 124,
          restaurant_name: "Stans Place Saskatoon",
          title: "p-stans-place-saskatoon",
          address: "110 Ruth Street East, Saskatoon, SK, Canada",
          phone: "+1 (306) 665-9000",
          available_days: [
            {
              id: 1746,
              day: "SUNDAY",
              opening_time: "08:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1746,
              day: "SUNDAY",
              opening_time: "00:00:00",
              closing_time: "03:00:00",
              order_mode: 1,
            },
            {
              id: 1747,
              day: "MONDAY",
              opening_time: "08:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1747,
              day: "MONDAY",
              opening_time: "00:00:00",
              closing_time: "03:00:00",
              order_mode: 1,
            },
            {
              id: 1748,
              day: "TUESDAY",
              opening_time: "08:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1748,
              day: "TUESDAY",
              opening_time: "00:00:00",
              closing_time: "03:00:00",
              order_mode: 1,
            },
            {
              id: 1749,
              day: "WEDNESDAY",
              opening_time: "08:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1749,
              day: "WEDNESDAY",
              opening_time: "00:00:00",
              closing_time: "03:00:00",
              order_mode: 1,
            },
            {
              id: 1750,
              day: "THURSDAY",
              opening_time: "08:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1750,
              day: "THURSDAY",
              opening_time: "00:00:00",
              closing_time: "03:00:00",
              order_mode: 1,
            },
            {
              id: 1751,
              day: "FRIDAY",
              opening_time: "08:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1751,
              day: "FRIDAY",
              opening_time: "00:00:00",
              closing_time: "03:00:00",
              order_mode: 1,
            },
            {
              id: 1752,
              day: "SATURDAY",
              opening_time: "08:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1752,
              day: "SATURDAY",
              opening_time: "00:00:00",
              closing_time: "03:00:00",
              order_mode: 1,
            },
          ],
          close_restaurent: false,
          lat: "52.10023821166007",
          lng: "-106.6694138434654",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },
      //3. PABCO Liquor Store & Bar
      {
        profile: {
          id: 124,
          restaurant_name: "PABCO Liquor Store & Bar",
          title: "p-pabco-liquor-prince-albert",
          address: "1425 6 Ave E, Prince Albert, SK S6V 1G2, Canada",
          phone: "+1 (306) 763-6222",
          available_days: [
            {
              id: 1746,
              day: "SUNDAY",
              opening_time: "10:00:00",
              closing_time: "20:00:00",
              order_mode: 1,
            },
            {
              id: 1747,
              day: "MONDAY",
              opening_time: "10:00:00",
              closing_time: "23:00:00",
              order_mode: 1,
            },
            {
              id: 1748,
              day: "TUESDAY",
              opening_time: "10:00:00",
              closing_time: "23:00:00",
              order_mode: 1,
            },
            {
              id: 1749,
              day: "WEDNESDAY",
              opening_time: "10:00:00",
              closing_time: "23:00:00",
              order_mode: 1,
            },
            {
              id: 1750,
              day: "THURSDAY",
              opening_time: "10:00:00",
              closing_time: "23:00:00",
              order_mode: 1,
            },
            {
              id: 1751,
              day: "FRIDAY",
              opening_time: "10:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1752,
              day: "SATURDAY",
              opening_time: "10:00:00",
              closing_time: "23:00:00",
              order_mode: 1,
            },
          ],
          close_restaurent: false,
          lat: "53.2001536985442",
          lng: "-105.73805251808527",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },
      //4. Jolly Roger Beer Store & Tavern
      {
        profile: {
          id: 124,
          restaurant_name: "Jolly Roger Beer Store & Tavern",
          title: "p-jolly-roger-regina",
          address: "4109 5th Ave, Regina, SK S4T 0M3, Canada",
          phone: "+1 (306) 522-0888",
          available_days: [
            {
              id: 1746,
              day: "SUNDAY",
              opening_time: "08:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1753,
              day: "SUNDAY",
              opening_time: "00:00:00",
              closing_time: "03:00:00",
              order_mode: 1,
            },
            {
              id: 1747,
              day: "MONDAY",
              opening_time: "08:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1754,
              day: "MONDAY",
              opening_time: "00:00:00",
              closing_time: "03:00:00",
              order_mode: 1,
            },
            {
              id: 1748,
              day: "TUESDAY",
              opening_time: "08:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1755,
              day: "TUESDAY",
              opening_time: "00:00:00",
              closing_time: "03:00:00",
              order_mode: 1,
            },
            {
              id: 1749,
              day: "WEDNESDAY",
              opening_time: "08:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1756,
              day: "WEDNESDAY",
              opening_time: "00:00:00",
              closing_time: "03:00:00",
              order_mode: 1,
            },
            {
              id: 1750,
              day: "THURSDAY",
              opening_time: "08:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1757,
              day: "THURSDAY",
              opening_time: "00:00:00",
              closing_time: "03:00:00",
              order_mode: 1,
            },
            {
              id: 1751,
              day: "FRIDAY",
              opening_time: "08:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1758,
              day: "FRIDAY",
              opening_time: "00:00:00",
              closing_time: "03:00:00",
              order_mode: 1,
            },
            {
              id: 1752,
              day: "SATURDAY",
              opening_time: "08:00:00",
              closing_time: "24:00:00",
              order_mode: 1,
            },
            {
              id: 1759,
              day: "SATURDAY",
              opening_time: "00:00:00",
              closing_time: "03:00:00",
              order_mode: 1,
            },
          ],
          close_restaurent: false,
          lat: "50.46131432509438",
          lng: "-104.63954748478798",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },
      //5. The Uptown Liquor Store & Bar
      {
        profile: {
          id: 124,
          restaurant_name: "The Uptown Liquor Store & Bar",
          title: "p-liquor-store-uptown-moosomin",
          address: "1001 S Front St, Moosomin, SK S0G 3N0, Canada",
          phone: "+1 (306) 435-4001",
          available_days: [
            {
              id: 1746,
              day: "SUNDAY",
              opening_time: "10:00:00",
              closing_time: "21:00:00",
              order_mode: 1,
            },
            {
              id: 1747,
              day: "MONDAY",
              opening_time: "10:00:00",
              closing_time: "21:00:00",
              order_mode: 1,
            },
            {
              id: 1748,
              day: "TUESDAY",
              opening_time: "10:00:00",
              closing_time: "21:00:00",
              order_mode: 1,
            },
            {
              id: 1749,
              day: "WEDNESDAY",
              opening_time: "10:00:00",
              closing_time: "21:00:00",
              order_mode: 1,
            },
            {
              id: 1750,
              day: "THURSDAY",
              opening_time: "10:00:00",
              closing_time: "21:00:00",
              order_mode: 1,
            },
            {
              id: 1751,
              day: "FRIDAY",
              opening_time: "10:00:00",
              closing_time: "21:00:00",
              order_mode: 1,
            },
            {
              id: 1752,
              day: "SATURDAY",
              opening_time: "10:00:00",
              closing_time: "21:00:00",
              order_mode: 1,
            },
          ],
          close_restaurent: false,
          lat: "50.145344618463085",
          lng: "-101.66488476865594",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },
      //6. Red Lion Inn Liquor Store
      {
        profile: {
          id: 124,
          restaurant_name: "Red Lion Inn Liquor Store",
          title: "red-lion-liquor-store-kindersley-5143",
          address: "614 Main St, Kindersley, SK S0L 1S0, Canada",
          phone: "+1 (306) 463-3019",
          available_days: [
            {
              id: 1746,
              day: "SUNDAY",
              opening_time: "00:00:00",
              closing_time: "00:00:00",
              order_mode: 1,
            },
            {
              id: 1747,
              day: "MONDAY",
              opening_time: "10:00:00",
              closing_time: "23:00:00",
              order_mode: 1,
            },
            {
              id: 1748,
              day: "TUESDAY",
              opening_time: "10:00:00",
              closing_time: "23:00:00",
              order_mode: 1,
            },
            {
              id: 1749,
              day: "WEDNESDAY",
              opening_time: "10:00:00",
              closing_time: "23:00:00",
              order_mode: 1,
            },
            {
              id: 1750,
              day: "THURSDAY",
              opening_time: "10:00:00",
              closing_time: "23:00:00",
              order_mode: 1,
            },
            {
              id: 1751,
              day: "FRIDAY",
              opening_time: "10:00:00",
              closing_time: "23:00:00",
              order_mode: 1,
            },
            {
              id: 1752,
              day: "SATURDAY",
              opening_time: "10:00:00",
              closing_time: "23:00:00",
              order_mode: 1,
            },
          ],
          close_restaurent: false,
          lat: "51.470188546376754",
          lng: "-109.15784981817612",
          get order_online_link() {
            return getOrderOnlineLink(this.title);
          },
        },
      },
    ],
  },
  message: "successful response",
};

export default storeDetails;
